import DateService from '@services/DateService'
import { proxy } from './proxy'

export const gimms = {
  getCuadrante: function (latitude: number, longitude: number) {
    const url = `https://geo.fas.usda.gov/arcgis2/rest/services/G_Overlay/LIS_Grid_Overlay/MapServer/0/query?where=%28I+%3E%3D+648+and+I+%3C%3D+667+and+J+%3E%3D351+and+J+%3C%3D+357%29+or%28+I+%3E+680+and+I+%3C+738+and+J+%3E384+and+J+%3C+417%29&text=&objectIds=&time=&timeRelation=esriTimeRelationOverlaps&geometry=${longitude}%2C${latitude}&geometryType=esriGeometryPoint&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=I%2C+J&returnGeometry=false&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&sqlFormat=none&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson`

    return proxy.getOld(url)
  },

  getGIMMSUrl: function (
    i: number,
    j: number,
    format: 'svg' | 'png',
    download: boolean,
    width: number = 1920,
    height: number = 1080
  ) {
    const nYears = 3
    const currentYear = DateService.now().year()
    const yearsUrl = Array.from(
      { length: nYears },
      (_, i) => `&years=${currentYear - i}`
    ).join('')

    let iValue = i.toString()
    if (iValue.length < 4) {
      iValue = `0${i}`
    }

    const attachment = download ? 1 : 0

    // 0689_391
    let url = `https://glam1.gsfc.nasa.gov/api/getplt/v5?version=v16&sat=MOD&shape=LIS&layer=NDVI&start_month=1&num_months=12&mcv=0`
    url += `&ids=${iValue}_${j}${yearsUrl}&stats=Mean&stats=Min&stats=Max&ts_type=seasonal&format=${format}&height=${height}&width=${width}&labels=0&attachment=${attachment}`
    return url
  }
}
